import React from 'react';
import PropTypes from 'prop-types';
import ForgeIcons from './ForgeIcons';

const Icon = (props) => {
  const { icon, iconSet, ...rest } = props;
  const IconComponent = iconSet[icon];
  if (!IconComponent) {
    throw new Error(
      `'${icon}' is not a valid value for prop 'icon'. Make sure you are passing a valid icon name; the 'icon' prop is case-sensitive.`
    );
  }
  return <IconComponent {...rest} />;
};

Icon.propTypes = {
  /** Adds a class to the SVG */
  className: PropTypes.string,
  /** Adds a state class to the SVG */
  disabled: PropTypes.bool,
  /** Adds a state class to the svg (if not also disabled) */
  error: PropTypes.string,
  /** Key used to determine the icon from the icon set */
  icon: PropTypes.string.isRequired,
  /** Specify a custon icon set defined as a dictionary of `IconBase` components. Icon sets can be generated using the [App Fabric Forge Component Generator](https://bitbucket.athenahealth.com/projects/UXDS/repos/app-fabric-generator-forge-component/browse). */
  iconSet: PropTypes.objectOf(PropTypes.func),
  /** Sets the size of the icon (a shortcut for setting height and width) */
  size: PropTypes.string,
  /** Sets the width of the icon */
  width: PropTypes.string,
  /** Sets the height of the icon */
  height: PropTypes.string,
  /** Sets the inline content of the `<title>` element in the SVG (which is read when a screen reader encounters the icon); defaults to the icon's name */
  title: PropTypes.string,
  /** Passthrough props to the root `<svg>` element */
  '...rest': PropTypes.object,
};

Icon.defaultProps = {
  iconSet: ForgeIcons,
};

export default Icon;
